module.exports = __webpack_public_path__ + "static/media/categories-icon.f00b3703.svg";